// extracted by mini-css-extract-plugin
export default {"section":"WelcomeBanner_section__Blyz1","title":"WelcomeBanner_title__N-kqb","appEntry":"WelcomeBanner_appEntry__xrq4P","appGrid":"WelcomeBanner_appGrid__ZYBoC"};